var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgW4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 13C37.66 13 37.34 13.08 37.06 13.24C34.66 6.14 27.92 1 20 1C12.08 1 5.36 6.12 2.94 13.24C2.66 13.08 2.34 13 2 13C0.9 13 0 13.9 0 15V19C0 20.1 0.9 21 2 21H4C5.1 21 6 20.1 6 19C6 11.28 12.28 5 20 5C27.72 5 34 11.28 34 19V21C34 26.72 30.54 31.66 25.62 33.82C25.26 33.32 24.66 33 24 33H20C18.9 33 18 33.9 18 35V37C18 38.1 18.9 39 20 39C29.92 39 38 30.92 38 21C39.1 21 40 20.1 40 19V15C40 13.9 39.1 13 38 13Z",
    fill: "#2A323F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 20C31.9998 13.38 26.6198 8 19.9998 8C13.3798 8 7.99982 13.38 7.99982 20C7.99982 26.62 13.3798 32 19.9998 32C26.6198 32 31.9998 26.62 31.9998 20ZM11.9998 20C11.9998 18.66 12.3598 17.42 12.9398 16.32C14.3798 18.02 16.4198 19.76 19.2798 20.86C21.2798 21.64 23.2198 21.9 24.9198 21.9C26.0198 21.9 26.9798 21.76 27.8398 21.6C27.0798 25.24 23.8598 27.98 19.9998 27.98C15.5798 27.98 11.9998 24.4 11.9998 19.98V20Z",
    fill: "#2A323F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW4);
export default __webpack_public_path__ + "static/media/w4.61b691ed43ed3a5fd9fb2fc4511b1eb0.svg";
export { ForwardRef as ReactComponent };